import * as yup from "yup";
import Toast from "helper/toast";

//////////////////// file sizes and formates ////////////////////
export const FILE_SIZE = 10_000_000; //10 meg

//////////////////// constant validation message ////////////////////
function strings({ title = "فیلد", size = "۵ مگ" }) {
  return {
    required: "این فیلد حتما باید پر شود",
    notMatch: title + " نامعتبر است ",
    size: `سایز ${title} باید کمتر از ${size} باشد`,
    min: `${title} حداقل باید ${size} کاراکتر باشد`,
    unSupported: `فرمت ${title} نامعتبر است`,
  };
}

/////////////////// convert empty stringToNull ///////////////////
function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === "string" && originalValue === "") {
    return null;
  }
  return value;
}

///////////////// Image validator ///////////////////
export function validateImg(file) {
  if (!(file.type.split("/")[0] === "image")) {
    return Toast({
      type: "custom",
      title: `فرمت عکس نامعبتر است`,
      autoClose: 3000,
    });
  } else if (file.size > FILE_SIZE) {
    return Toast({
      type: "custom",
      //converting kb to megabyte
      title: `حجم عکس باید کمتر از ${FILE_SIZE / 1_000_000}  مگ باشد`,
      autoClose: 3000,
    });
  }
}

///////////////// File validator ///////////////////
export function validateFile(file, file_type, title, limit, ...file_format) {
  if (!file) return false;
  if (
    file_type &&
    file_type !== "png" &&
    file_type !== "jpg" &&
    file_type !== "jpeg" &&
    file_type !== "gif" &&
    file_type !== "svg" &&
    file_type !== "pdf" &&
    file_type !== "zip" &&
    file_type !== "7zip" &&
    file_type !== "rar"
  ) {
    Toast({
      type: "custom",
      title: `فرمت فایل ${title} نامعبتر است. (${file_format.join()})`,
      autoClose: 4000,
    });
    return false;
  }
  if (file && file.size > limit) {
    Toast({
      type: "custom",
      title: `حجم فایل ${title} باید کمتر از ${limit / 1_000_000}  مگ باشد`,
      autoClose: 4000,
    });
    return false;
  }
  return true;
}

////////////////// privacy ///////////////////
export const textContentSchema = yup
  .object({
    content: yup.string().required(strings("").required),
  })
  .required();

////////////////// about us validation ///////////////////
export const aboutUsSchema = yup
  .object({
    phone_number_one: yup
      .string()
      .matches(/^(|.{11,})$/, strings({ title: "شماره تماس 1", size: 11 }).min)
      .required(strings({ title: "شماره تماس 1" }).required)
      .nullable(),
    phone_number_two: yup
      .string()
      .matches(/^(|.{11,})$/, strings({ title: "شماره تماس 2", size: 11 }).min)
      .required(strings({ title: "2شماره تماس" }).required)
      .nullable(),
    instagram: yup
      .string()
      .required(strings({ title: "اینستاگرام" }).required)
      .nullable(),
    keyword: yup
      .string()

      .nullable(),
    meta_description: yup
      .string()

      .nullable(),
    alt: yup
      .string()

      .nullable(),
    telegram: yup
      .string()
      .required(strings({ title: "تلگرام" }).required)
      .nullable(),
    whatsapp: yup
      .string()
      .required(strings({ title: "واتساپ" }).required)
      .nullable(),
    email: yup
      .string()
      .email(strings({ title: "ایمیل" }).notMatch)
      .nullable(),
    address: yup
      .string()
      .required(strings({ title: "آدرس" }).required)
      .nullable(),
  })
  .required();

///////////////// user validate /////////////////////
export const userSchema = yup
  .object({
    // if admin wants to change fields below, uncomment them.
    full_name: yup.string().required(strings({ title: "نام" }).required),
    phone_number: yup
      .string()
      .min(11, strings({ title: "شماره تماس", size: 11 }).min)
      .required(strings({ title: "شماره تماس" }).required),

    email: yup
      .string()
      .email(strings({ title: "ایمیل" }).notMatch)
      .required(strings({ title: "ایمیل" }).required),

    address: yup.string(),
    birth_date: yup.string(),
  })
  .required();

/////////////// categories schema /////////////////////
export const categorySchema = yup
  .object({
    title: yup.string().required(strings({ title: "عنوان" }).required),
  })
  .required();

/////////////// addPageItems Schema ////////////////
export const pageItemSchema = yup
  .object({
    title: yup.string().required(strings({ title: "عنوان" }).required),
    category: yup.string().required(strings({ title: "سردسته" }).required),
    alt: yup.string().nullable(),
    keyword: yup.string().nullable(),
    meta_description: yup.string().nullable(),
  })
  .required();

/////////////// services category schema
export const serviceSubCategorySchema = yup
  .object({
    title: yup.string().required(strings({ title: "عنوان زیردسته" }).required),
    category: yup
      .string()
      .required(strings({ title: "عنوان سردسته" }).required),
  })
  .required();

/////////////// product add item schema //////////////
export const productAddItemSchema = yup
  .object({
    title: yup.string().required(strings({ title: "عنوان محصول" }).required),
    category: yup
      .string()
      .required(strings({ title: "عنوان سردسته" }).required),
    subCategory: yup
      .string()
      .required(strings({ title: "عنوان زیردسته" }).required),
    alt: yup.string().nullable(),
    keyword: yup.string().nullable(),
    meta_description: yup.string().nullable(),
  })
  .required();
/////////////// worksample add item schema //////////////
export const workSampleSchema = yup
  .object({
    title: yup.string().required(strings({ title: "عنوان محصول" }).required),
    link: yup.string().nullable(),
    alt: yup.string().nullable(),
    keyword: yup.string().nullable(),
    meta_description: yup.string().nullable(),
  })
  .required();

/////////////// NotificationSchema schema //////////////
export const NotificationSchema = yup
  .object({
    text: yup
      .string()
      .required(strings({ title: "متن پیام" }).required)
      .nullable(),
  })
  .required();

///////////// slide content schema /////////////
export const slideContentSchema = yup
  .object({
    text: yup.string().required(strings({ title: "متن" }).required),
    title: yup.string().required(strings({ title: "عنوان" }).required),
    link: yup.string().required(strings({ title: "لینک" }).required),
    alt: yup.string().nullable(),
    keyword: yup.string().nullable(),
  })
  .required();
///////////// gallery content schema /////////////
export const galleryContentSchema = yup
  .object({
    alt: yup.string().nullable(),
    keyword: yup.string().nullable(),
    meta_description: yup.string().nullable(),
  })
  .required();
